import React from 'react';
import { FiTrash2, FiX } from 'react-icons/fi';
import { Button } from '../ui/Button';

interface DeleteServiceModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteServiceModal: React.FC<DeleteServiceModalProps> = ({ onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div
        className="w-full max-w-110 bg-[#0c0c0c] border border-white/10 rounded-[40px] overflow-hidden shadow-2xl p-8"
        style={{ animation: 'fadeInScale 0.2s ease-out' }}
      >
        <div className="flex justify-between items-start mb-6">
          <h3 className="text-white text-[20px] font-semibold">Delete Service</h3>
          <button
            onClick={onCancel}
            className="p-1 text-zinc-500 hover:text-white transition-colors"
          >
            <FiX size={24} />
          </button>
        </div>

        <div className="flex flex-col items-center gap-6 py-4">
          <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center text-red-500">
            <FiTrash2 size={32} />
          </div>
          <p className="text-white text-[22px] font-medium text-center leading-tight">
            Are you sure you want to delete this Service?
          </p>
        </div>

        <div className="flex gap-4 mt-8">
          <Button
            variant="outline"
            size="lg"
            className="flex-1 rounded-full h-14 border-zinc-800 text-white hover:bg-white/5"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="lg"
            className="flex-1 rounded-full h-14 bg-red-500 text-white hover:bg-red-600 border-0"
            onClick={onConfirm}
          >
            Yes, Delete
          </Button>
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};
